export const redirectToDashboard = () => {
    window.location.href = `${import.meta.env.HAL_LEGACY_URL}/livepac/`;
};
